// src/components/layouts/BlankLayout.js
import React from 'react';

const BlankLayout = ({ children }) => {
  return <div>{children}</div>;
};

export default BlankLayout;
